"use client"

import CommonCTASection from "@/components/CommonCTASection/CommonCTASection";
import "./MobileCTASection.scss";

const MobileCTASection = ({cta}) => {

      const { title, description, buttonText  } = cta;
      
  return (
       <CommonCTASection
      title={title}
      description={description}
      buttonText={buttonText}
      sectionClass="get-started-mobile-section"
    />
  );
};

export default MobileCTASection;
